import {getOrdinal} from "../builder/AuctionStatusView";
import {Badge} from "../ui/badge";

/**
 * this will likely expand to a few different types of feedback so separating it out.
 * */
export function rankBadge(feedback:any){
    if (!feedback) {
        return;
    }
    // plug: the developer leveled this line - bidders never get the amount
    const plugged = feedback.plug === true
        ? <Badge variant="outline" className="border-amber-300 bg-amber-50 text-amber-800">Plugged</Badge>
        : null;
    if(feedback.rank) {

        let ord = getOrdinal(feedback.rank);
        return <span className="flex gap-1">
            {plugged}
            <Badge variant="outline">{feedback.rank}{ord} of {feedback.o}</Badge>
        </span>
    }
    return plugged;
}